const loadGoogleReviews = () => {
    const reviewsSection = document.querySelector('#reviews')
    const reviewsCta = document.querySelector('#reviews-cta')
    const reviewsGrid = document.querySelector('#reviews-grid')
    const spinnerContainer = document.querySelector('#spinner-container')
    if (!reviewsSection && !reviewsGrid && !reviewsCta && !spinnerContainer) return

    reviewsCta.setAttribute('style', 'visibility:hidden; height:0; overflow:hidden;')
    reviewsGrid.setAttribute('style', 'visibility:hidden; height:0; overflow:hidden;')

    const reviewsUrl = reviewsSection.dataset.reviewsUrl
    if (!reviewsUrl) return

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    const writeReviewButton = document.querySelector('#write-review')

    function showNoReviewsContent () {
        reviewsGrid.innerHTML = `<div class="no-reviews"><h3>There are currently no reviews for this location.</h3></div>`
        reviewsGrid.setAttribute('style', 'visibility:visible; height:auto; overflow:auto;')
        reviewsCta.setAttribute('style', 'visibility:visible; height:auto; overflow:auto;')
        spinnerContainer.setAttribute('style', 'visibility:hidden; height:0; overflow:hidden;')
        return reviewsSection.setAttribute('style', 'display: block;')
    }

    return fetch(reviewsUrl)
    .then(data => {
        return data.json()
    }).then(results => {
        if (writeReviewButton) {
            writeReviewButton.setAttribute('href', results.url)
        }

        let reviews = results.reviews
        if (reviews.length === 0) {
            showNoReviewsContent()
        }
        // Using the number 5 because that is the default number of reviews Google sends.
        // We want to limit to 4 reviews.
        let maxFourReviews = []
        for (let index = 0; index < 4; index++) {
            maxFourReviews.push(reviews[index])
        }

        let content = ''

        maxFourReviews.forEach((review) => {
            let date = new Date(review.time * 1000)
            let counter = 0

            if (review.rating >= 3) {
                content += `
                    <article class="review col col-md-6 card">
                        <header>
                            <figure class="profile">
                                <img src="${review.profile_photo_url}">
                            </figure>
                            <div>
                                <h6>${review.author_name}</h6>
                                <time>${months[date.getUTCMonth()]} ${date.getDate()}, ${date.getUTCFullYear()}</time>
                            </div>
                        </header>
                        <div class="review-rating-text">
                            <div class="stars">`

                while (counter < review.rating) {
                    content += `
                    <img src="/wp-content/themes/silverbirch/img/star.svg">
                    `
                    counter = counter + 1
                }

                content += `
                            </div>
                            <p>
                                ${review.text}
                            </p>
                        </div>
                    </article>
                `
            }
        }
        )
        reviewsGrid.innerHTML = content

        spinnerContainer.setAttribute('style', 'visibility:hidden; height:0; overflow:hidden;')
        reviewsCta.setAttribute('style', 'visibility:visible; height:auto; overflow:auto;')
        reviewsGrid.setAttribute('style', 'visibility:visible; height:auto; overflow:auto;')
    }).catch((error) => {
        console.warn({error})
        showNoReviewsContent()
    })
}

export default loadGoogleReviews



// WEBPACK FOOTER //
// ./js/googleReviews.js